import {
  getOGCustomer,
  getOGUpcomingOrders,
  addItemToNextBox,
  sortOGOrders,
} from './ordergroove-api-helper'
import {
  createFromItem,
  getOGOrder,
} from './ordergroove-api-helper'

export default () => ({
  open: false,
  closeModal() {
    this.open = false
    const event = new CustomEvent('webhook-modal-closed')
    window.dispatchEvent(event)
  },
  openModal() {
    this.open = true
    setTimeout(addFocusTrap, 15)
  },
  init() {
    document.addEventListener('DOMContentLoaded', initializeOGAuth)
    const purchaseOptionsModal = document.querySelector('.purchase-options-modal')
    purchaseOptionsModal && purchaseOptionsModal.classList.remove('hidden')
    window.addEventListener('webhook-close-modal', () => {
      this.closeModal()
    })
  }
})

function addFocusTrap() {
  const purchaseOptionsModal = document.querySelector('.purchase-options-modal')
  let userModal = document.querySelector('.not-subscriber-modal-options')

  const nextOrderButton = document.querySelector('#add-to-next-box-button')
  const nextOrderOneTimeButton = document.querySelector('#add-one-time-button')
  const isUserWithSubscription = window.ogCustomer && window.ogUpcomingOrders.count > 0

  if (nextOrderButton && nextOrderOneTimeButton && isUserWithSubscription) {
    userModal = document.querySelector('.subscriber-modal-options')
  }

  const previousFocusElement = document.activeElement
  const closeButtonElement =
    purchaseOptionsModal.querySelector('.button__close-modal')
  const focusableElements =
    '[tabindex]:not([tabindex="-1"]), [href], button, input'
  const modalFocusableElements =
    userModal.querySelectorAll(focusableElements)
  const firstFocusableElement =
    purchaseOptionsModal.querySelectorAll(focusableElements)[0]
  const focusableContent = [closeButtonElement, ...modalFocusableElements]
  const lastFocusableElement = focusableContent[focusableContent.length - 1]

  closeButtonElement.focus()

  function focusTrap(e) {
    let isTabPressed = e.key === 'Tab' || e.keyCode === 9
    let isEscPressed = e.key === 'Escape' || e.keyCode === 27

    if (isEscPressed) {
      document.removeEventListener('keydown', focusTrap)
      previousFocusElement.focus()
      const event = new CustomEvent('webhook-close-modal')
      window.dispatchEvent(event)
    }

    if (!isTabPressed) {
      return
    }

    if (e.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus()
        e.preventDefault()
        e.stopPropagation()
      }
    } else {
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus()
        e.preventDefault()
        e.stopPropagation()
      }
    }
  }

  window.addEventListener('webhook-modal-closed', () => {
    previousFocusElement.focus()
    purchaseOptionsModal.removeEventListener('keydown', focusTrap)
  })

  purchaseOptionsModal.addEventListener('keydown', focusTrap)
}

async function toggleInNextBoxMessage(nextOrder) {
  const purchaseOptionsModal = document.querySelector('.purchase-options-modal')
  const ogNextOrder = await getOGOrder(nextOrder.public_id)
  const productsInNextOrder = ogNextOrder.results.reduce(
    (result, { product }) => {
      result[product] = true
      return result
    },
    {},
  )
  const productId = purchaseOptionsModal.getAttribute('data-product-variant-id')
  const userWithSubOptions = document.querySelector('.user-with-sub-options')
  const productInNextBoxMessage = document.querySelector(
    '.product-in-next-box-message',
  )
  const productInNextBoxMessageText = document.querySelector(
    '.product-in-next-box-message-text',
  )

  const userLocale = new Intl.NumberFormat().resolvedOptions().locale
  const nextOrderDate = new Date(nextOrder.place).toLocaleDateString(
    userLocale,
    { month: 'short', day: 'numeric' },
  )
  productInNextBoxMessageText.innerHTML = `Look out for this product in your next box scheduled for ${nextOrderDate}`

  if (productsInNextOrder[productId]) {
    userWithSubOptions.classList.add('hide')
    productInNextBoxMessage.classList.remove('hide')
    return 'shown'
  } else {
    userWithSubOptions.classList.remove('hide')
    productInNextBoxMessage.classList.add('hide')
    return 'hidden'
  }
}

window.toggleInNextBoxMessage = toggleInNextBoxMessage

function showModalOptions(option) {
  const notSubscriberModalOptions = document.querySelector(
    '.not-subscriber-modal-options',
  )
  const subscriberModalOptions = document.querySelector(
    '.subscriber-modal-options',
  )
  if (!notSubscriberModalOptions || !subscriberModalOptions) return

  switch (option) {
    case 'no-subscriber':
      subscriberModalOptions.classList.add('hide')
      notSubscriberModalOptions.classList.remove('hide')
      break
    case 'subscriber':
      notSubscriberModalOptions.classList.add('hide')
      subscriberModalOptions.classList.remove('hide')
      break
    default:
      break
  }
}

function updateSubscriptionButtons() {
  const purchaseOptionsTypeButtons = document.querySelectorAll('input[name="purchase-option"]')
  if (purchaseOptionsTypeButtons.length) {
    for (let i = 0; i < purchaseOptionsTypeButtons.length; i++) {
      purchaseOptionsTypeButtons[i].addEventListener('click', (event) => {
        const subscribeOptions = document.querySelector('.subscribe-options')
        const oneTimeOptions = document.querySelector('.one-time-options')
        switch (event.target.value) {
          case 'one-time':
            subscribeOptions.classList.add('hide')
            oneTimeOptions.classList.remove('hide')
            break
          case 'subscribe':
            subscribeOptions.classList.remove('hide')
            oneTimeOptions.classList.add('hide')
            break
          default:
            break
        }
      })
    }
  }
}

async function initializeOGAuth() {

  await window.dsc?.ensureSubscriberHydrated?.()

  const ogCustomer = await getOGCustomer(window?.dsc?.customerId)
  const ogUpcomingOrders = await getOGUpcomingOrders(window?.dsc?.customerId)
  window.isOGInitialized = true

  if (ogUpcomingOrders && ogUpcomingOrders.results.length) {
    sortOGOrders(ogUpcomingOrders.results)
  }
  window.ogCustomer = ogCustomer
  window.ogUpcomingOrders = ogUpcomingOrders

  const nextOrderButton = document.querySelector('#add-to-next-box-button')
  const nextOrderOneTimeButton = document.querySelector('#add-one-time-button')
  const isUserWithSubscription = ogCustomer && ogUpcomingOrders.count > 0

  const purchaseOptionsModal = document.querySelector('.purchase-options-modal')

  // check if user has an active subscription and setup custom og impulse upsell button and find the earliest subscription box
  if (nextOrderOneTimeButton && nextOrderButton && isUserWithSubscription) {
    const nextOrder = ogUpcomingOrders.results[0]

    // set date on button
    const userLocale = new Intl.NumberFormat().resolvedOptions().locale
    const nextOrderDate = new Date(nextOrder.place).toLocaleDateString(
      userLocale,
      { month: 'short', day: 'numeric' },
    )
    nextOrderButton.innerHTML = `Add to Next Box on ${nextOrderDate}`
    nextOrderOneTimeButton.innerHTML = `Add to Next Box on ${nextOrderDate}`

    showModalOptions('subscriber')

    nextOrderOneTimeButton.addEventListener('click', async (event) => {
      event.preventDefault()
      const orderId = nextOrder.public_id
      const productId = purchaseOptionsModal.getAttribute(
        'data-product-id',
      )
      const productSku = purchaseOptionsModal.getAttribute('data-product-sku')
      const productName = purchaseOptionsModal.getAttribute('data-product-name')
      const productCategory = purchaseOptionsModal.getAttribute('data-product-category')
      const productVariantId = purchaseOptionsModal.getAttribute(
        'data-product-variant-id',
      )
      const productVariantName = purchaseOptionsModal.getAttribute('data-product-variant-name')
      const productPrice = purchaseOptionsModal.getAttribute(
        'data-product-variant-price',
      )
      await addItemToNextBox({
        order: orderId,
        product: productVariantId,
        quantity: 1,
      })
      
      // Fire analytics event
      if (window.dsc && typeof window.dsc.fireDlAddToNextBoxEvent === 'function') {
        // Create product data object from modal attributes
        const productData = {
          id: productId,
          title: productName,
          type: productCategory,
          variants: [{
            id: productVariantId,
            title: productVariantName,
            price: parseFloat(productPrice) * 100, // Convert to cents for consistency
            sku: productSku
          }]
        };

        window.dsc.fireDlAddToNextBoxEvent(
          'add-one-time-to-next-box',
          productVariantId,
          productSku,
          1,
          null,
          productData
        );
      }

      if (ogUpcomingOrders && ogUpcomingOrders.results.length) {
        toggleInNextBoxMessage(ogUpcomingOrders.results[0])
      } else {
        window.dispatchEvent(new CustomEvent("open-modal"))
      }
      event.stopPropagation()
    })

    const subscribeOptionsButton = document.querySelector(
      '.subscriber-frequency',
    )
    if (subscribeOptionsButton) {
      subscribeOptionsButton.addEventListener('click', async (e) => {
        e.preventDefault()
        const selectedFrequency = document.querySelector(
          'input[name="subscriber-frequency"]:checked',
        )
        const sellingFrequency = selectedFrequency.getAttribute(
          'data-selling-plan-frequency',
        
        )
        const selectedSellingPlan = document.querySelector(
          'input[name="subscriber-frequency"]:checked',
        )
        const sellingPlanId = selectedSellingPlan.getAttribute(
          'data-selling-plan-id',
        )
        const orderId = ogUpcomingOrders.results[0].public_id
        const productId = purchaseOptionsModal.getAttribute('data-product-id');
        const productSku = purchaseOptionsModal.getAttribute('data-product-sku');
        const productName = purchaseOptionsModal.getAttribute('data-product-name');
        const productCategory = purchaseOptionsModal.getAttribute('data-product-category');
        const productVariantId = purchaseOptionsModal.getAttribute('data-product-variant-id');
        const productVariantName = purchaseOptionsModal.getAttribute('data-product-variant-name');
        const productPrice = purchaseOptionsModal.getAttribute('data-product-variant-price');
        const response = await addItemToNextBox({
          order: orderId,
          product: productVariantId,
          quantity: 1,
        });
        await createFromItem({
          item: response.public_id,
          every: sellingFrequency,
        })

        if (ogUpcomingOrders && ogUpcomingOrders.results.length) {
          toggleInNextBoxMessage(ogUpcomingOrders.results[0])
        } else {
          window.dispatchEvent(new CustomEvent("open-modal"))
        }
        // Fire analytics event
        if (window.dsc && typeof window.dsc.fireDlAddToNextBoxEvent === 'function') {
          const productData = {
            id: productId,
            title: productName,
            type: productCategory,
            variants: [{
              id: productVariantId,
              title: productVariantName,
              price: parseFloat(productPrice) * 100, // Convert to cents for consistency
              sku: productSku
            }],
            selling_plan_groups: [{
              selling_plans: [{
                id: sellingPlanId,
                name: document.querySelector(`input[value="${sellingPlanId}"]`)?.closest('label')?.textContent.trim() || 'Subscription'
              }]
            }]
          };

          window.dsc.fireDlAddToNextBoxEvent(
            'subscribe',
            productVariantId,
            productSku,
            1,
            sellingPlanId,
            productData
          );
        }
        e.stopPropagation()
      })
    }
  } else {
    const frequencyOptionsButtons = [
      ...document.querySelectorAll('input[name="not-subscriber-frequency"]')
    ]
    const form = purchaseOptionsModal?.querySelector('form')
    if (frequencyOptionsButtons.length && form) {
      const existingSellingPlanInputs = purchaseOptionsModal.querySelectorAll('[name=selling_plan]')
      existingSellingPlanInputs.forEach(existingSellingPlanInput => existingSellingPlanInput.remove())

      const sellingPlanInput = document.createElement('input')
      sellingPlanInput.setAttribute('type', 'hidden')
      sellingPlanInput.setAttribute('name', 'selling_plan')
      form.appendChild(sellingPlanInput)
      form.querySelector('[name=selling_plan]').value = document.querySelector(
        'input[name="not-subscriber-frequency"]:checked',
      ).value

      frequencyOptionsButtons.forEach(frequencyOptionsButton => {
        frequencyOptionsButton.addEventListener('change', (event) => {
          form.querySelector('[name=selling_plan]').value = event.target.value
          event.stopPropagation()
        }, true)
      })
    }
  }

  updateSubscriptionButtons()
}